/* Options:
Date: 2024-11-25 08:33:40
Version: 4.514
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: http://localhost:1876

//GlobalNamespace: 
//MakePropertiesOptional: True
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
//DefaultImports: 
*/

export interface IGet {}
export interface IPost {}

export interface IReturnVoid
{
    createResponse() : void;
}

export interface IReturn<T>
{
    createResponse() : T;
}

// @DataContract
export class ResponseError
{
    // @DataMember(Order=1, EmitDefaultValue=false)
    errorCode: string;

    // @DataMember(Order=2, EmitDefaultValue=false)
    fieldName: string;

    // @DataMember(Order=3, EmitDefaultValue=false)
    message: string;

    // @DataMember(Order=4, EmitDefaultValue=false)
    meta: { [index:string]: string; };
}

// @DataContract
export class ResponseStatus
{
    // @DataMember(Order=1)
    errorCode: string;

    // @DataMember(Order=2)
    message: string;

    // @DataMember(Order=3)
    stackTrace: string;

    // @DataMember(Order=4)
    errors: ResponseError[];

    // @DataMember(Order=5)
    meta: { [index:string]: string; };
}

export class ContactUsSettings
{
    rightHtmlText: string;
    recipientEmails: string;
}

export class FileRequests
{
}

export class ForumBase
{
    id: number;
    obsolete: boolean;
    createdByMemberId: number;
    createdByMemberName: string;
    creationDate: string;
    modifiedByMemberId: number;
    modifiedByMemberName: string;
    modifiedDate: string;
}

export class ForumAttachmentMetaData extends ForumBase
{
    fileName: string;
    fileType: string;
}

export class ForumMember extends ForumBase
{
    forumId: number;
    memberTypeId: number;
    type: string;
    email: string;
    firstName: string;
    lastName: string;
    name: string;
    avatarEncoded: string;
    avatarFile: Object;
    locked: boolean;
    lastLoginDate: string;
    notified: boolean;
    lastNotifiedDate: string;
    lastActivityDate: string;
    forumAttachmentId: number;
    avatar: ForumAttachmentMetaData;
    notificationFrequencyDays: number;
    notificationImmediate: boolean;
    isAdmin: boolean;
    lastAccessedDate: string;
    forumPermissions: { [index:number]: string; };
    online: boolean;
}

export class ForumTagSummary
{
    id: number;
    forumPostId: number;
    forumResourceId: number;
    name: string;
    obsolete: boolean;
    rank: number;
}

export class ForumAttachment extends ForumBase
{
    data: string;
    fileName: string;
    fileType: string;
}

export class ForumPostReactionSummary
{
    forumMemberId: number;
    name: string;
    type: string;
}

export class ForumPost extends ForumBase
{
    forumId: number;
    parentId: number;
    linkForumReferenceDataId: number;
    linkType: string;
    link: string;
    comment: string;
    forumMemberId: number;
    forumMemberName: string;
    forumMemberAvatarId: number;
    maxModifiedDate: string;
    tags: ForumTagSummary[];
    forumAttachmentId: number;
    file: ForumAttachment;
    reactions: ForumPostReactionSummary[];
    rootForumPostId: number;
    subscribed: boolean;
}

export class ForumTag
{
    id: number;
    forumId: number;
    name: string;
    typeForumReferenceDataId: number;
    type: string;
    obsolete: boolean;
    pinned: boolean;
    rank: number;
}

export class ForumNotification
{
    id: number;
    forumPostId: number;
    notificationType: string;
    forumMemberId: number;
    createdByForumMemberId: number;
    avatarId: number;
    firstName: string;
    lastName: string;
    notificationOnly: boolean;
    creationDate: string;
    markAsRead: boolean;
}

export class ForumResource extends ForumBase
{
    forumId: number;
    linkForumReferenceDataId: number;
    linkType: string;
    link: string;
    title: string;
    summary: string;
    author: string;
    year: number;
    rank: number;
    favourite: boolean;
    anchor: string;
    tags: ForumTagSummary[];
    forumAttachmentId: number;
    file: ForumAttachment;
}

export class Forum extends ForumBase
{
    title: string;
    defaultMessage: string;
    defaultMessageType: number;
    defaultMessageDismissable: boolean;
    theme: string;
    themeColour: string;
    rank: number;
    defaultResourceMessage: string;
    lastActivityDate: string;
    currentUser: ForumMember;
    activePost: ForumPost;
    posts: ForumPost[];
    activeTag: ForumTag[];
    notifications: ForumNotification[];
    tags: ForumTag[];
    activeMember: ForumMember;
    members: ForumMember[];
    activeResource: ForumResource;
    resources: ForumResource[];
    subscribed: boolean;
    notificationCount: number;
    isResourceTabDefault: boolean;
}

export class ForumMemberWithAvatar extends ForumBase
{
    forumId: number;
    memberTypeId: number;
    type: string;
    email: string;
    firstName: string;
    lastName: string;
    name: string;
    avatarEncoded: string;
    avatarFile: Object;
    locked: boolean;
    lastLoginDate: string;
    notified: boolean;
    lastNotifiedDate: string;
    lastActivityDate: string;
    forumAttachmentId: number;
    avatar: ForumAttachment;
    isAdmin: boolean;
    online: boolean;
}

export class ForumMemberWithPassword extends ForumBase
{
    email: string;
    firstName: string;
    lastName: string;
    password: string;
}

export class ForumPostReaction
{
    id: number;
    forumPostId: number;
    forumMemberId: number;
    name: string;
    type: string;
}

export class AboutUsSettings
{
    missionHtmlText: string;
    logoHtmlText: string;
}

export class HomeSettings
{
    sectionOneText: string;
    sectionOneLinkText: string;
    sectionOneLink: string;
    sectionTwoText: string;
    sectionTwoLinkText: string;
    sectionTwoLink: string;
}

export class ResearchState
{
    id: number;
    researchId: number;
    stateId: number;
    state: State;
    enabled: boolean;
    createdByMemberId: number;
    creationDate: string;
    modifiedByMemberId: number;
    modifiedDate: string;
}

export class State
{
    id: number;
    stateName: string;
    researchState: ResearchState[];
    publicationState: PublicationState[];
    createdByMemberId: number;
    creationDate: string;
    modifiedDate: string;
    enabled: boolean;
    modifiedByMemberId: number;
}

export class PublicationState
{
    id: number;
    publicationId: number;
    stateId: number;
    state: State;
    enabled: boolean;
    createdByMemberId: number;
    creationDate: string;
    modifiedByMemberId: number;
    modifiedDate: string;
}

export class ResearchFocus
{
    id: number;
    researchId: number;
    focusId: number;
    focus: Focus;
    enabled: boolean;
    createdByMemberId: number;
    creationDate: string;
    modifiedByMemberId: number;
    modifiedDate: string;
}

export class Focus
{
    id: number;
    focusName: string;
    researchFocus: ResearchFocus[];
    publicationFocus: PublicationFocus[];
    createdByMemberId: number;
    creationDate: string;
    modifiedDate: string;
    enabled: boolean;
    modifiedByMemberId: number;
}

export class PublicationFocus
{
    id: number;
    publicationId: number;
    focusId: number;
    focus: Focus;
    enabled: boolean;
    createdByMemberId: number;
    creationDate: string;
    modifiedByMemberId: number;
    modifiedDate: string;
}

export class PeopleCategory
{
    id: number;
    subtitle: string;
    peopleId: number;
    people: People;
    categoryId: number;
    categoryName: string;
    link: string;
    text: string;
    anchor: string;
    anchorName: string;
    sortOrder: number;
    enabled: boolean;
}

export class People
{
    id: number;
    firstName: string;
    lastName: string;
    title: string;
    subTitle: string;
    anchor: string;
    link: string;
    img: string;
    peopleType: number;
    enabled: boolean;
    sortOrder: number;
    anchorName: string;
    firstNameLastName: string;
    peopleCategories: PeopleCategory[];
    peopleCategoriesDisplay: string;
}

export class PublicationPeople
{
    id: number;
    publicationId: number;
    peopleId: number;
    people: People;
    sortOrder: number;
    enabled: boolean;
    createdByMemberId: number;
    creationDate: string;
    modifiedByMemberId: number;
    modifiedDate: string;
}

export class PublicationType
{
    id: number;
    publicationTypeName: string;
    enabled: boolean;
    createdByMemberId: number;
    creationDate: string;
    modifiedByMemberId: number;
    modifiedDate: string;
}

export class Publication
{
    id: number;
    anchor: string;
    type: number;
    title: string;
    titleExt: string;
    publishedby: string;
    year: string;
    isResource: boolean;
    summary: string;
    link: string;
    sortOrder: number;
    isInternational: boolean;
    enabled: boolean;
    createdByMemberId: number;
    creationDate: string;
    modifiedByMemberId: number;
    modifiedDate: string;
    display: string;
    publicationState: PublicationState[];
    publicationFocus: PublicationFocus[];
    publicationPeople: PublicationPeople[];
    publicationType: PublicationType;
    states: string[];
    focus: string[];
    authors: string[];
}

export class ResearchPeople
{
    id: number;
    researchId: number;
    peopleCategoryId: number;
    peopleCategory: PeopleCategory;
    peopleId: number;
    people: People;
    sortOrder: number;
    enabled: boolean;
    createdByMemberId: number;
    creationDate: string;
    modifiedByMemberId: number;
    modifiedDate: string;
    name: string;
    link: string;
}

export class ResearchPublication
{
    id: number;
    researchId: number;
    publicationId: number;
    publication: Publication;
    enabled: boolean;
    createdByMemberId: number;
    creationDate: string;
    modifiedByMemberId: number;
    modifiedDate: string;
}

export class ResearchContact
{
    id: number;
    researchId: number;
    name: string;
    email: string;
    subject: string;
    enabled: boolean;
    createdByMemberId: number;
    creationDate: string;
    modifiedByMemberId: number;
    modifiedDate: string;
}

export class Research
{
    id: number;
    anchor: string;
    title: string;
    titleLine1: string;
    titleLine2: string;
    summaryTitleLine1: string;
    summaryTitleLine2: string;
    theme: string;
    forumId: number;
    recruiting: boolean;
    images: string;
    fundingBody: string;
    content: string;
    sortOrder: number;
    enabled: boolean;
    createdByMemberId: number;
    creationDate: string;
    modifiedByMemberId: number;
    modifiedDate: string;
    researchState: ResearchState[];
    researchFocus: ResearchFocus[];
    researchPeople: ResearchPeople[];
    researchPeopleInternal: ResearchPeople[];
    researchPeopleExternal: ResearchPeople[];
    researchPublication: ResearchPublication[];
    researchContact: ResearchContact[];
}

export class News
{
    id: number;
    promoted: boolean;
    title: string;
    subtitle: string;
    anchor: string;
    enabled: boolean;
    img: string;
    caption: string;
    date: string;
    creationDate: string;
    dateDisplay: string;
    text: string;
    isEmpty: boolean;
    link: string;
    sortOrder: number;
}

export class Category
{
    id: number;
    categoryName: string;
    enabled: boolean;
}

export class PeopleBase
{
    id: number;
    categoryId: number;
    anchor: string;
    title: string;
    subtitle: string;
    img: string;
    caption: string;
    date: string;
    text: string;
    link: string;
    sortOrder: number;
    anchorName: string;
}

export class AboutPeople extends PeopleBase
{
}

export class SiteData
{
    homeSettings: HomeSettings;
    aboutUsSettings: AboutUsSettings;
    contactUsSettings: ContactUsSettings;
    aboutPeople: AboutPeople[];
    news: News[];
    research: Research[];
    resources: Publication[];
    publications: Publication[];
    publicationTypes: PublicationType[];
    focus: Focus[];
}

export class GetContactUsResponse
{
    responseStatus: ResponseStatus;
    contactUsSettings: ContactUsSettings;
}

export class PostContactUsResponse
{
    responseStatus: ResponseStatus;
    contactUsSettings: ContactUsSettings;
}

export class ContactUsResponse
{
    result: string;
}

export class UploadTemporaryFileResponse
{
    responseStatus: ResponseStatus;
    imgPath: string;
}

export class ForumResponse
{
    responseStatus: ResponseStatus;
    forum: Forum;
}

export class BaseResponse
{
    responseStatus: ResponseStatus;
    success: boolean;
}

export class ForumListResponse
{
    responseStatus: ResponseStatus;
    forums: Forum[];
}

export class ForumLoginResponse
{
    responseStatus: ResponseStatus;
    userId: string;
    sessionId: string;
    userName: string;
    displayName: string;
    bearerToken: string;
}

export class ForumPostSearchResponse
{
    responseStatus: ResponseStatus;
    posts: ForumPost[];
}

export class ForumMemberSearchResponse
{
    responseStatus: ResponseStatus;
    members: ForumMember[];
}

export class ForumResourceSearchResponse
{
    responseStatus: ResponseStatus;
    resources: ForumResource[];
}

export class ForumMemberResponse
{
    responseStatus: ResponseStatus;
    member: ForumMember;
}

export class ForumSearchResponse
{
    responseStatus: ResponseStatus;
    forums: Forum[];
}

export class ForumResourceResponse
{
    responseStatus: ResponseStatus;
    resource: ForumResource;
}

export class ForumPostResponse
{
    responseStatus: ResponseStatus;
    post: ForumPost;
}

export class ForumTagResponse
{
    responseStatus: ResponseStatus;
    tag: ForumTag;
}

export class SubscribeResponse
{
    responseStatus: ResponseStatus;
    isSubscribed: boolean;
}

export class TagSummaryResponse
{
    responseStatus: ResponseStatus;
    tag: ForumTagSummary;
    id: number;
}

export class ResetPasswordResponse
{
    responseStatus: ResponseStatus;
}

export class ResetPasswordUpdateResponse
{
    responseStatus: ResponseStatus;
    success: boolean;
}

export class FollowPostResponse
{
    responseStatus: ResponseStatus;
    postId: number;
    subscribed: boolean;
}

export class GetAboutUsResponse
{
    responseStatus: ResponseStatus;
    aboutUsSettings: AboutUsSettings;
}

export class PostAboutUsResponse
{
    responseStatus: ResponseStatus;
    aboutUsSettings: AboutUsSettings;
}

export class GetHomeResponse
{
    responseStatus: ResponseStatus;
    homeSettings: HomeSettings;
}

export class PostHomeResponse
{
    responseStatus: ResponseStatus;
    homeSettings: HomeSettings;
}

export class GetPublicationResponse
{
    responseStatus: ResponseStatus;
    publication: Publication[];
    focus: Focus[];
    states: State[];
    people: People[];
    publicationTypes: PublicationType[];
}

export class PostPublicationResponse
{
    responseStatus: ResponseStatus;
    publication: Publication;
}

export class GetResearchResponse
{
    responseStatus: ResponseStatus;
    research: Research[];
    focus: Focus[];
    states: State[];
    people: People[];
    publication: Publication[];
}

export class PostResearchResponse
{
    responseStatus: ResponseStatus;
    research: Research;
}

export class GetNewsResponse
{
    responseStatus: ResponseStatus;
    news: News[];
}

export class PostNewsResponse
{
    responseStatus: ResponseStatus;
    news: News;
}

export class GetPeopleResponse
{
    responseStatus: ResponseStatus;
    people: People[];
    categories: Category[];
}

export class PostPeopleResponse
{
    responseStatus: ResponseStatus;
    people: People;
}

export class GetSiteDataResponse
{
    responseStatus: ResponseStatus;
    siteData: SiteData;
}

// @DataContract
export class AuthenticateResponse
{
    // @DataMember(Order=1)
    userId: string;

    // @DataMember(Order=2)
    sessionId: string;

    // @DataMember(Order=3)
    userName: string;

    // @DataMember(Order=4)
    displayName: string;

    // @DataMember(Order=5)
    referrerUrl: string;

    // @DataMember(Order=6)
    bearerToken: string;

    // @DataMember(Order=7)
    refreshToken: string;

    // @DataMember(Order=8)
    responseStatus: ResponseStatus;

    // @DataMember(Order=9)
    meta: { [index:string]: string; };
}

// @DataContract
export class AssignRolesResponse
{
    // @DataMember(Order=1)
    allRoles: string[];

    // @DataMember(Order=2)
    allPermissions: string[];

    // @DataMember(Order=3)
    responseStatus: ResponseStatus;
}

// @DataContract
export class UnAssignRolesResponse
{
    // @DataMember(Order=1)
    allRoles: string[];

    // @DataMember(Order=2)
    allPermissions: string[];

    // @DataMember(Order=3)
    responseStatus: ResponseStatus;
}

// @DataContract
export class ConvertSessionToTokenResponse
{
    // @DataMember(Order=1)
    meta: { [index:string]: string; };

    // @DataMember(Order=2)
    responseStatus: ResponseStatus;
}

// @DataContract
export class GetAccessTokenResponse
{
    // @DataMember(Order=1)
    accessToken: string;

    // @DataMember(Order=2)
    responseStatus: ResponseStatus;
}

// @Route("/api/contactus", "GET")
export class GetContactUs implements IReturn<GetContactUsResponse>, IGet
{
    createResponse() { return new GetContactUsResponse(); }
    getTypeName() { return "GetContactUs"; }
}

// @Route("/api/contactus", "POST")
export class PostContactUs implements IReturn<PostContactUsResponse>, IPost
{
    contactUsSettings: ContactUsSettings;
    createResponse() { return new PostContactUsResponse(); }
    getTypeName() { return "PostContactUs"; }
}

// @Route("/api/contactus")
export class ContactUsMessage implements IReturn<ContactUsResponse>
{
    firstName: string;
    lastName: string;
    state: string;
    message: string;
    email: string;
    phone: string;
    researchTraining: boolean;
    researchInvolvement: boolean;
    collaborating: boolean;
    news: boolean;
    enquiry: boolean;
    donation: boolean;
    other: boolean;
    otherDescription: string;
    createResponse() { return new ContactUsResponse(); }
    getTypeName() { return "ContactUsMessage"; }
}

// @Route("/api/file/temporary", "POST")
export class UploadTemporaryFile implements IReturn<UploadTemporaryFileResponse>
{
    createResponse() { return new UploadTemporaryFileResponse(); }
    getTypeName() { return "FileRequests.UploadTemporaryFile"; }
}

// @Route("/temporaryfile/{Id}", "GET")
export class GetFileTemporary
{
    id: string;
}

// @Route("/file/{Id}", "GET")
// @Route("/file/{Id}/{Slug*}", "GET")
export class GetFile
{
    id: number;
    slug: string;
}

// @Route("/api/forum/{id}/updates", "GET")
export class GetForumUpdate implements IReturn<ForumResponse>
{
    id: number;
    email: string;
    createResponse() { return new ForumResponse(); }
    getTypeName() { return "GetForumUpdate"; }
}

// @Route("/api/jobs/weeklyrollup", "GET")
export class ProcessAdhocSummaryEmails implements IReturn<BaseResponse>
{
    createResponse() { return new BaseResponse(); }
    getTypeName() { return "ProcessAdhocSummaryEmails"; }
}

// @Route("/api/forum/{id}", "GET")
export class GetForum implements IReturn<ForumResponse>
{
    id: number;
    summary: boolean;
    createResponse() { return new ForumResponse(); }
    getTypeName() { return "GetForum"; }
}

// @Route("/api/post/{id}", "GET")
export class GetForumPost implements IReturn<ForumResponse>
{
    id: number;
    forumPostId: number;
    createResponse() { return new ForumResponse(); }
    getTypeName() { return "GetForumPost"; }
}

// @Route("/api/forum/", "GET")
export class GetForumList implements IReturn<ForumListResponse>
{
    email: string;
    createResponse() { return new ForumListResponse(); }
    getTypeName() { return "GetForumList"; }
}

// @Route("/api/authenticate", "POST")
export class ForumLogin implements IReturn<ForumLoginResponse>
{
    provider: string;
    userName: string;
    password: string;
    rememberMe: boolean;
    createResponse() { return new ForumLoginResponse(); }
    getTypeName() { return "ForumLogin"; }
}

// @Route("/api/attachment/{id}", "GET")
export class GetForumAttachment implements IReturn<Object>
{
    id: number;
    createResponse() { return new Object(); }
    getTypeName() { return "GetForumAttachment"; }
}

// @Route("/api/forum/{id}/post/search/{term}", "GET")
export class GetForumPostSearch implements IReturn<ForumPostSearchResponse>
{
    id: number;
    term: string;
    createResponse() { return new ForumPostSearchResponse(); }
    getTypeName() { return "GetForumPostSearch"; }
}

// @Route("/api/forum/{id}/member/search/{term}", "GET")
export class GetForumMemberSearch implements IReturn<ForumMemberSearchResponse>
{
    id: number;
    term: string;
    createResponse() { return new ForumMemberSearchResponse(); }
    getTypeName() { return "GetForumMemberSearch"; }
}

// @Route("/api/forum/{id}/resource/search/{term}", "GET")
export class GetForumResourceSearch implements IReturn<ForumResourceSearchResponse>
{
    id: number;
    term: string;
    createResponse() { return new ForumResourceSearchResponse(); }
    getTypeName() { return "GetForumResourceSearch"; }
}

// @Route("/api/user/{id}", "GET")
export class GetCurrentForumMember implements IReturn<ForumMemberResponse>
{
    createResponse() { return new ForumMemberResponse(); }
    getTypeName() { return "GetCurrentForumMember"; }
}

// @Route("/api/member/{id}", "GET")
export class GetForumMember implements IReturn<ForumMemberResponse>
{
    id: number;
    createResponse() { return new ForumMemberResponse(); }
    getTypeName() { return "GetForumMember"; }
}

// @Route("/api/forum/search/{term}", "GET")
export class GetForumsSearch implements IReturn<ForumSearchResponse>
{
    term: string;
    email: string;
    createResponse() { return new ForumSearchResponse(); }
    getTypeName() { return "GetForumsSearch"; }
}

// @Route("/api/forum", "POST")
export class CreateForum implements IReturn<ForumResponse>
{
    forum: Forum;
    createResponse() { return new ForumResponse(); }
    getTypeName() { return "CreateForum"; }
}

// @Route("/api/resources/sort", "PUT")
export class SortResourceItem implements IReturn<ForumResourceSearchResponse>
{
    forumId: number;
    resourceId: number;
    newIndex: number;
    oldIndex: number;
    createResponse() { return new ForumResourceSearchResponse(); }
    getTypeName() { return "SortResourceItem"; }
}

// @Route("/api/member/settings/frequency", "PUT")
export class UpdateEmailFrequencySetting implements IReturn<ForumResponse>
{
    value: number;
    createResponse() { return new ForumResponse(); }
    getTypeName() { return "UpdateEmailFrequencySetting"; }
}

// @Route("/api/member/settings/notification", "PUT")
export class UpdateNotificationSetting implements IReturn<ForumResponse>
{
    active: boolean;
    createResponse() { return new ForumResponse(); }
    getTypeName() { return "UpdateNotificationSetting"; }
}

// @Route("/api/forum", "PUT")
export class UpdateForum implements IReturn<ForumResponse>
{
    forum: Forum;
    createResponse() { return new ForumResponse(); }
    getTypeName() { return "UpdateForum"; }
}

// @Route("/api/forum/member", "POST")
export class CreateForumMember implements IReturn<ForumMemberResponse>
{
    member: ForumMemberWithAvatar;
    createResponse() { return new ForumMemberResponse(); }
    getTypeName() { return "CreateForumMember"; }
}

// @Route("/api/forum/member", "PUT")
export class UpdateForumMember implements IReturn<ForumMemberResponse>
{
    member: ForumMemberWithAvatar;
    createResponse() { return new ForumMemberResponse(); }
    getTypeName() { return "UpdateForumMember"; }
}

// @Route("/api/forum/member", "PUT")
export class UpdateForumMemberPassword implements IReturn<ForumMemberResponse>
{
    member: ForumMemberWithPassword;
    createResponse() { return new ForumMemberResponse(); }
    getTypeName() { return "UpdateForumMemberPassword"; }
}

// @Route("/api/forum/{id}/post", "PUT")
export class UpdateForumPost implements IReturn<ForumResponse>
{
    post: ForumPost;
    taggedMembers: ForumMember[];
    id: number;
    createResponse() { return new ForumResponse(); }
    getTypeName() { return "UpdateForumPost"; }
}

// @Route("/api/forum/{id}/resource", "POST")
export class CreateForumResource implements IReturn<ForumResourceResponse>
{
    resource: ForumResource;
    id: number;
    createResponse() { return new ForumResourceResponse(); }
    getTypeName() { return "CreateForumResource"; }
}

// @Route("/api/forum/{id}/resource/{resourceId}", "PATCH")
export class FlagForumResource implements IReturn<ForumResourceResponse>
{
    id: number;
    resourceId: number;
    createResponse() { return new ForumResourceResponse(); }
    getTypeName() { return "FlagForumResource"; }
}

// @Route("/api/forum/{id}/post/{forumPostId}/member/{forumMemberId}/reaction", "PATCH")
export class UpdateForumPostReaction implements IReturn<ForumPostResponse>
{
    postReaction: ForumPostReaction;
    id: number;
    forumMemberId: number;
    forumPostId: number;
    createResponse() { return new ForumPostResponse(); }
    getTypeName() { return "UpdateForumPostReaction"; }
}

// @Route("/api/forum/{id}/resource", "PUT")
export class UpdateForumResource implements IReturn<ForumResourceResponse>
{
    resource: ForumResource;
    id: number;
    createResponse() { return new ForumResourceResponse(); }
    getTypeName() { return "UpdateForumResource"; }
}

// @Route("/api/forum/{id}/tag", "POST")
export class CreateForumTag implements IReturn<ForumTagResponse>
{
    tag: ForumTag;
    id: number;
    createResponse() { return new ForumTagResponse(); }
    getTypeName() { return "CreateForumTag"; }
}

// @Route("/api/forum/{id}/tag", "PUT")
export class UpdateForumTag implements IReturn<ForumTagResponse>
{
    tag: ForumTag;
    id: number;
    createResponse() { return new ForumTagResponse(); }
    getTypeName() { return "UpdateForumTag"; }
}

// @Route("/api/forum/{id}/subscribe", "PUT")
export class SubscribeForum implements IReturn<SubscribeResponse>
{
    id: number;
    createResponse() { return new SubscribeResponse(); }
    getTypeName() { return "SubscribeForum"; }
}

// @Route("/api/forum/{id}/resource/{id}/tag", "PATCH")
export class AddResourceTag implements IReturn<TagSummaryResponse>
{
    tag: ForumTagSummary;
    tagId: number;
    id: number;
    createResponse() { return new TagSummaryResponse(); }
    getTypeName() { return "AddResourceTag"; }
}

// @Route("/api/member/resetpassword", "PATCH")
export class ResetPassword implements IReturn<ResetPasswordResponse>
{
    email: string;
    createResponse() { return new ResetPasswordResponse(); }
    getTypeName() { return "ResetPassword"; }
}

// @Route("/api/member/resetpassword/save", "PATCH")
export class ResetPasswordUpdate implements IReturn<ResetPasswordUpdateResponse>
{
    email: string;
    token: string;
    password: string;
    createResponse() { return new ResetPasswordUpdateResponse(); }
    getTypeName() { return "ResetPasswordUpdate"; }
}

// @Route("/api/forum/{id}/post/{id}/tag", "PATCH")
export class AddPostTag implements IReturn<TagSummaryResponse>
{
    tag: ForumTagSummary;
    tagId: number;
    id: number;
    createResponse() { return new TagSummaryResponse(); }
    getTypeName() { return "AddPostTag"; }
}

// @Route("/api/forum/{id}/post/{postId}/tagMember", "PATCH")
export class FollowPost implements IReturn<FollowPostResponse>
{
    memberId: number;
    postId: number;
    unfollow: boolean;
    createResponse() { return new FollowPostResponse(); }
    getTypeName() { return "FollowPost"; }
}

// @Route("/api/aboutus", "GET")
export class GetAboutUs implements IReturn<GetAboutUsResponse>, IGet
{
    createResponse() { return new GetAboutUsResponse(); }
    getTypeName() { return "GetAboutUs"; }
}

// @Route("/api/aboutus", "POST")
export class PostAboutUs implements IReturn<PostAboutUsResponse>, IPost
{
    aboutUsSettings: AboutUsSettings;
    createResponse() { return new PostAboutUsResponse(); }
    getTypeName() { return "PostAboutUs"; }
}

// @Route("/api/home", "GET")
export class GetHome implements IReturn<GetHomeResponse>, IGet
{
    createResponse() { return new GetHomeResponse(); }
    getTypeName() { return "GetHome"; }
}

// @Route("/api/home", "POST")
export class PostHome implements IReturn<PostHomeResponse>, IPost
{
    homeSettings: HomeSettings;
    createResponse() { return new PostHomeResponse(); }
    getTypeName() { return "PostHome"; }
}

// @Route("/api/publication", "GET")
export class GetPublication implements IReturn<GetPublicationResponse>
{
    createResponse() { return new GetPublicationResponse(); }
    getTypeName() { return "GetPublication"; }
}

// @Route("/api/publication", "POST")
export class PostPublication implements IReturn<PostPublicationResponse>
{
    publication: Publication;
    createResponse() { return new PostPublicationResponse(); }
    getTypeName() { return "PostPublication"; }
}

// @Route("/api/research", "GET")
export class GetResearch implements IReturn<GetResearchResponse>
{
    createResponse() { return new GetResearchResponse(); }
    getTypeName() { return "GetResearch"; }
}

// @Route("/api/research", "POST")
export class PostResearch implements IReturn<PostResearchResponse>, IPost
{
    research: Research;
    createResponse() { return new PostResearchResponse(); }
    getTypeName() { return "PostResearch"; }
}

// @Route("/api/news", "GET")
export class GetNews implements IReturn<GetNewsResponse>
{
    createResponse() { return new GetNewsResponse(); }
    getTypeName() { return "GetNews"; }
}

// @Route("/api/news", "POST")
export class PostNews implements IReturn<PostNewsResponse>
{
    news: News;
    createResponse() { return new PostNewsResponse(); }
    getTypeName() { return "PostNews"; }
}

// @Route("/api/people", "GET")
export class GetPeople implements IReturn<GetPeopleResponse>
{
    createResponse() { return new GetPeopleResponse(); }
    getTypeName() { return "GetPeople"; }
}

// @Route("/api/people", "POST")
export class PostPeople implements IReturn<PostPeopleResponse>
{
    people: People;
    createResponse() { return new PostPeopleResponse(); }
    getTypeName() { return "PostPeople"; }
}

// @Route("/api/sitedata", "GET")
export class GetSiteData implements IReturn<GetSiteDataResponse>, IGet
{
    createResponse() { return new GetSiteDataResponse(); }
    getTypeName() { return "GetSiteData"; }
}

// @Route("/auth")
// @Route("/auth/{provider}")
// @Route("/authenticate")
// @Route("/authenticate/{provider}")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    // @DataMember(Order=1)
    provider: string;

    // @DataMember(Order=2)
    state: string;

    // @DataMember(Order=3)
    oauth_token: string;

    // @DataMember(Order=4)
    oauth_verifier: string;

    // @DataMember(Order=5)
    userName: string;

    // @DataMember(Order=6)
    password: string;

    // @DataMember(Order=7)
    rememberMe: boolean;

    // @DataMember(Order=8)
    continue: string;

    // @DataMember(Order=9)
    nonce: string;

    // @DataMember(Order=10)
    uri: string;

    // @DataMember(Order=11)
    response: string;

    // @DataMember(Order=12)
    qop: string;

    // @DataMember(Order=13)
    nc: string;

    // @DataMember(Order=14)
    cnonce: string;

    // @DataMember(Order=15)
    useTokenCookie: boolean;

    // @DataMember(Order=16)
    accessToken: string;

    // @DataMember(Order=17)
    accessTokenSecret: string;

    // @DataMember(Order=18)
    meta: { [index:string]: string; };
    createResponse() { return new AuthenticateResponse(); }
    getTypeName() { return "Authenticate"; }
}

// @Route("/assignroles")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    userName: string;

    // @DataMember(Order=2)
    permissions: string[];

    // @DataMember(Order=3)
    roles: string[];
    createResponse() { return new AssignRolesResponse(); }
    getTypeName() { return "AssignRoles"; }
}

// @Route("/unassignroles")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    userName: string;

    // @DataMember(Order=2)
    permissions: string[];

    // @DataMember(Order=3)
    roles: string[];
    createResponse() { return new UnAssignRolesResponse(); }
    getTypeName() { return "UnAssignRoles"; }
}

// @Route("/session-to-token")
// @DataContract
export class ConvertSessionToToken implements IReturn<ConvertSessionToTokenResponse>, IPost
{
    // @DataMember(Order=1)
    preserveSession: boolean;
    createResponse() { return new ConvertSessionToTokenResponse(); }
    getTypeName() { return "ConvertSessionToToken"; }
}

// @Route("/access-token")
// @DataContract
export class GetAccessToken implements IReturn<GetAccessTokenResponse>, IPost
{
    // @DataMember(Order=1)
    refreshToken: string;
    createResponse() { return new GetAccessTokenResponse(); }
    getTypeName() { return "GetAccessToken"; }
}



// WEBPACK FOOTER //
// ./src/CRE.dtos.ts